"use strict";

var PlanCardFeatures = require("app/screens/Pricing/components/PlanSelector/plan-card-features");

var PlanCardProFeatures = React.createClass({
  mixins: [ReactIntl.IntlMixin],

  getFeaturesMessages: function() {
    var unlimitedEntries = this.getIntlMessage("pricing.features.unlimited_entries");
    var unlimitedEntriesExplained = this.getIntlMessage("pricing.features.unlimited_entries_explained");
    var unlimitedStorage = this.getIntlMessage("pricing.features.unlimited_storage");
    var storageExplained = this.getIntlMessage("pricing.features.storage_explained");
    var customFeatures = this.getIntlMessage("pricing.features.custom_features");
    var customFeaturesExplained = this.getIntlMessage("pricing.features.custom_features_explained");
    var privacyContol = this.getIntlMessage("pricing.features.privacy_contol");
    var privacyContolExplained = this.getIntlMessage("pricing.features.privacy_contol_explained");
    var integrationRD = this.getIntlMessage("pricing.features.integration_rd");
    var integrationRdExplained = this.getIntlMessage("pricing.features.integration_rd_explained");
    var automaticEmail = this.getIntlMessage("pricing.features.automatic_email");
    var automaticEmailExplained = this.getIntlMessage("pricing.features.automatic_email_explained");
    var mobileSync = this.getIntlMessage("pricing.features.mobile_sync");
    var mobileSyncExplained = this.getIntlMessage("pricing.features.mobile_sync_explained");
    var customerSuccess = this.getIntlMessage("pricing.features.customer_success_pro");
    var integrationGoogleAgendas = this.getIntlMessage("pricing.features.integration_google_agendas");
    var integrationGoogleAgendasExplained = this.getIntlMessage("pricing.features.integration_google_agendas_explained");
    var zapierIntegration = this.getIntlMessage("pricing.features.zapier_integration");
    var zapierIntegrationExplained = this.getIntlMessage("pricing.features.zapier_integration_explained");
    var apiAccess = this.getIntlMessage("pricing.features.api_access");
    var apiAccessExplained = this.getIntlMessage("pricing.features.api_access_explained");
    var teamLevelAccess = this.getIntlMessage("pricing.features.team_level_access");
    var teamLevelAccessExplained = this.getIntlMessage("pricing.features.team_level_access_explained");
    var monthlyReport = this.getIntlMessage("pricing.features.monthly_report");
    var monthlyReportExplained = this.getIntlMessage("pricing.features.monthly_report_explained");
    var whatsappIntegration = this.getIntlMessage("pricing.features.whatsapp_integration");
    var whatsappIntegrationExplained = this.getIntlMessage("pricing.features.whatsapp_integration_explained");

    var features = [
      { text: customFeatures, tooltipText: customFeaturesExplained },
      { text: privacyContol, tooltipText: privacyContolExplained },
      { text: teamLevelAccess, tooltipText: teamLevelAccessExplained },
      { text: monthlyReport, tooltipText: monthlyReportExplained },
      { text: whatsappIntegration, tooltipText: whatsappIntegrationExplained },
      { text: integrationRD, tooltipText: integrationRdExplained },
      { text: integrationGoogleAgendas, tooltipText: integrationGoogleAgendasExplained },
      { text: zapierIntegration, tooltipText: zapierIntegrationExplained },
      { text: apiAccess, tooltipText: apiAccessExplained },
      { text: automaticEmail, tooltipText: automaticEmailExplained },
      { text: unlimitedEntries, tooltipText: unlimitedEntriesExplained },
      { text: unlimitedStorage, tooltipText: storageExplained },
      { text: mobileSync, tooltipText: mobileSyncExplained },
      { text: customerSuccess }
    ];

    return features;
  },

  render: function() {
    return (
      <div className="mt-50">
        <PlanCardFeatures features={this.getFeaturesMessages()} />
      </div>
    );
  }
});

module.exports = PlanCardProFeatures;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/plan-card-pro-features.jsx